export default "__VITE_ASSET__82532a8f__"